"use client";
import Link, { type LinkProps } from "next/link";
import { type ComponentPropsWithoutRef, type PropsWithChildren } from "react";
import { useCreateInformaURL } from "@/hooks/useCreateInformaURL";
import { useGetDecoratedURI } from "@/hooks/useGetDecoratedURI";

export interface AnchorProps
  extends LinkProps,
    Pick<ComponentPropsWithoutRef<"a">, "className"> {
  openInNewTab?: boolean;
  relativeURI?: boolean;
  extendedURI?: boolean;
}

export default function Anchor(props: PropsWithChildren<AnchorProps>) {
  const {
    href,
    openInNewTab,
    children,
    relativeURI,
    extendedURI = true,
    ...restProps
  } = props;
  const { u } = useCreateInformaURL(relativeURI);
  const uri = extendedURI ? u(href.toString()) : href;
  const decoratedURI = useGetDecoratedURI(uri as string);

  if (openInNewTab) {
    return (
      <Link
        href={decoratedURI}
        target="_blank"
        rel="noreferrer"
        prefetch={false}
        {...restProps}
      >
        {children}
      </Link>
    );
  }

  return (
    <Link href={decoratedURI} prefetch={false} {...restProps}>
      {children}
    </Link>
  );
}
